import { configData } from '../config';

const hostOf = (url) => {
    try {
        return new URL(url).host.toLowerCase();
    } catch (e) {
        return '';
    }
};

// The host name the header and footer compare with the RSMWW_*_DOMAIN settings to pick the site's
// logo and buttons. Two hosts count as the main SMWW site (RSMWW_DOMAIN):
// - the local dev server;
// - the team site (RSMWW_TEAM_URL). On the live site the team host is the main site of this app
//   (live's RSMWW_DOMAIN is team.sportsmanagementworldwide.com), so it shows the SMWW logo and the
//   Apply Now buttons; alpha serves it beside the main host, which RSMWW_DOMAIN names.
export function siteDomainName() {
    const host = window.location.host.toLowerCase();
    if (/^(localhost|127\.0\.0\.1)(:\d+)?$/.test(host)) {
        return configData.RSMWW_DOMAIN;
    }
    const teamHost = hostOf(configData.RSMWW_TEAM_URL);
    if (teamHost && host === teamHost) {
        return configData.RSMWW_DOMAIN;
    }
    return host;
}
